<template>
  <div
    v-if="ticket"
    >
    <ticket-dialog
      v-if="ticket.fix && ticket.fix.payments[0]"
      :id="ticket.fix.payments[0].id"
      :key="ticket.fix.payments[0].id"
      ref="ticket"
      ></ticket-dialog>

    <div class="d-flex flex-row align-center fill-width pa-3 white">
      <GoBack 
        class="shrink pr-3"
        />
      <div 
        class="grow"
        >
        <h2>
          {{ ticket.title }}
        </h2>
        <span
          class="grey--text caption"
          >
          {{ $t('states.' + ticket.state) }} - {{ (new Date(ticket.createdAt)).toLocaleDateString() }}
        </span>
      </div>
      <div 
        cols="4" 
        class="d-flex justify-end"
        >
        <v-btn 
          @click.stop="editModal = true" 
          outlined
          >
          {{ $t('action.edit') }}
        </v-btn>
      </div>
    </div>

    <v-dialog
      v-model="editModal"
      width="600px"
      >
      <v-card>
        <v-card-title>
          {{ $t('action.edit') }}
        </v-card-title>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="form"
            lazy-validation
            >
            <v-row>
              <v-col
                cols="6"
                class="py-0"
                >
                <v-text-field
                  v-model="ticket.title"
                  filled
                  label="Título"
                  hint="* Obligatorio"
                  :rules="[ v => !!v || 'Campo obligatorio']"
                  ></v-text-field>
              </v-col>

              <v-col
                cols="6"
                class="py-0"
                >
                <v-select
                  :items="states"
                  v-model="ticket.state"
                  filled
                  label="Estado"
                  hint="* Obligatorio"
                  :rules="[ v => !!v || 'Campo obligatorio']"
                  ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions
          class="px-6 pb-6 pt-0 justify-end"
          >
          <v-btn 
            @click.stop="cancel" 
            text
            color="blue lighten-1"
            >
            {{ $t('action.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            @click="editTicket"
            >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container>
      <h3>
        Reparación
      </h3>

      <v-card
        flat
        color="transparent"
        v-if="ticket.fix"
        @click="$refs.ticket.dialog = true"
        class="mt-3"
        >
        <v-card
          class="rounded-lg"
          >
          <v-card-text
            class="text-subtitle-1 black--text py-2 d-flex flex-row justify-space-between align-center"
            >
            <div
              class="d-flex flex-column"
              >
              <span>
                {{ ticket.fix.name }}
              </span>
              <span
                class="caption"
                >
                {{ (new Date(ticket.fix.fixedAt)).toLocaleDateString() }}
              </span>
            </div>

            <div
              class="d-flex align-center"
              style="gap: 4px"
              >
              <div>
                ${{ ticket.fix.payments[0].amount.toLocaleString('es-AR') }}
              </div>

              <div>
                <v-dialog
                  v-model="dialog"
                  width="500"
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="red lighten-2"
                      icon
                      v-bind="attrs"
                      v-on="on"
                      >
                      <v-icon>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title>
                      Eliminar arreglo
                    </v-card-title>

                    <v-card-text>
                      ¿Está seguro de que desea eliminar este arreglo? Esta acción no se puede deshacer.
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="dialog = false"
                        >
                        Cancelar
                      </v-btn>

                      <v-btn
                        color="error"
                        @click="deleteFix(ticket.fix.id)"
                        >
                        Eliminar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-card>
      
      <v-alert
        v-else
        color="info lighten-2"
        class="mt-3"
        outlined
        >
        No tiene una reparación asociada. Haga click <strong @click="createFixModal = true" style="cursor: pointer;">aquí</strong> para crearla.
      </v-alert>

      <v-dialog
        v-model="createFixModal"
        width="600"
        >
        <v-card>
          <v-card-title>
            {{ $t('action.add_fix') }}
            <v-spacer></v-spacer>
            <v-btn
              icon
              color="primary"
              @click="modal = false"
              >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-form
              v-model="valid_fix"
              lazy-validation
              ref="fix_form"
              >
              <v-text-field
                filled
                v-model="fix.name"
                label="Nombre"
                placeholder="Reparación de techo"
                :rules="rules"
                hint="*Obligatorio"
                persistent-hint
                >
              </v-text-field>

              <v-autocomplete
                v-model="concept"
                label="Concepto"
                :items="concepts"
                item-text="name"
                return-object
                filled
                :hint="concepts.length ? 'Obligatorio' : ''"
                :rules="concepts.length ? rules.required : []"
                persistent-hint
                ></v-autocomplete>

              <v-select
                v-model="referral"
                :items="referrals"
                item-text="name"
                return-object
                filled
                label="Pagado por"
                hint="*Obligatorio" 
                persistent-hint
                :rules="rules"
                >
              </v-select>

              <div
                class="d-flex justify-space-between"
                >
                <v-text-field
                  filled
                  v-model="fix.amount"
                  label="Costo"
                  placeholder="2500"
                  class="mr-2"
                  suffix="ARS"
                  :rules="rules"
                  hint="*Obligatorio"
                  persistent-hint
                  >
                </v-text-field>

                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fix.fixedAt"
                      class="ml-2"
                      label="Fecha del arreglo"
                      append-icon="mdi-calendar-blank"
                      readonly
                      filled
                      v-bind="attrs"
                      v-on="on"
                      ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fix.fixedAt"
                    @input="endMenu = false"
                    ></v-date-picker>
                </v-menu>
              </div>

              <v-textarea
                filled
                v-model="fix.description"
                label="Descripción"
                placeholder="Lorem ipsum dolorem..."
                persistent-hint
                >
                </v-textarea>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              @click="createFix"
              >
              Crear
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <h3
        class="mt-6"
        >
        Comentarios
      </h3>

      <template
        v-for="(description, idx) in ticket.descriptions"
        >
        <v-card
          class="mt-3"
          >
          <v-card-subtitle
            class="grey lighten-4 py-2 mb-3"
            >
            <span
              class="text-subtitle-2"
              >
              #{{ idx + 1}} 
            </span>
            <span
              class="caption"
              >
              - {{ (new Date(description.createdAt)).toLocaleString() }}
            </span>
          </v-card-subtitle>
          <v-card-text>
            {{ description.description }}
          </v-card-text>
        </v-card>
      </template>

      <v-card
        class="mt-3"
        >
        <v-card-subtitle>
          Agregar comentario
        </v-card-subtitle>

        <v-card-text
          class="d-flex flex-row"
          >
          <v-textarea
            v-model="comment"
            filled
            hide-details
            label="Comentario"
            ></v-textarea>
          <v-btn
            class="ml-3 align-self-end"
            @click="addComment"
            color="primary"
            >
            Agregar
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { Ticket } from '@/graphql/queries/ticket'
import { EditTicket } from '@/graphql/mutations/tickets'
import { CreateFix, DeleteFix } from '@/graphql/mutations/properties'
import { Concepts } from '@/graphql/queries/concepts'

import GoBack from '@/components/GoBack'
import TicketDialog from '@/components/payments/Ticket'

export default {
  data () {
    return {
      ticket: null,
      valid: true,
      valid_fix: true,
      editModal: false,
      comment: null,
      createFixModal: false,
      dialog: false,
      menu: false,
      rules: [
        v => !!v || '*Obligatorio'
      ],
      concepts: [],
      concept: null,
      fix: {
        name: null,
        description: null,
        propertyId: null,
        ticketId: null,
        contractId: null,
        state: null,
        fixedAt: null,
        amount: 0,
        payerId: null,
        payerType: 'User',
        paymentsAttributes: [
          {
            referralId: null,
            referralType: null,
            concept: 'Reparaciones',
            conceptId: null,
            state: 'pending',
            period: "0",
            dueDate: (new Date()),
            amount: 0,
            subAccountId: null,
            contractId: null,
          }
        ] 
      },
      referral: {
        name: null,
        referralType: null,
        referralId: null
      },
      payer: {
        name: null,
        referralType: null,
        referralId: null
      },
    }
  },

  components: {
    GoBack,
    TicketDialog,
  },

  computed: {
    states () { 
      return [
        {
          text: 'Pendiente',
          value: 'pending',
        },
        {
          text: 'En curso',
          value: 'ongoing',
        },
        {
          text: 'Esperando respuesta',
          value: 'on_hold',
        },
        {
          text: 'En observación',
          value: 'watching',
        },
        {
          text: 'Finalizado',
          value: 'success',
        },
      ]
    },

    referrals () {
      if (this.ticket) {
        return [
          { name: 'Locatario', referralId: this.ticket.contract.property.activeTenant.id, referralType: 'User' },
          { name: 'Locador', referralId: this.ticket.contract.property.owner[0].id, referralType: 'User' },
          { name: 'Inmobiliaria', referralId: this.ticket.contract.property.agencyId, referralType: 'Agency' },
        ]
      }
    }
  },

  watch: {
    referral: {
      handler (val) {
        if (val.referralType == 'Agency') {
          this.fix.paymentsAttributes.splice(1, 1)
        } else {
          this.fix.paymentsAttributes[1].referralType = val.referralType
          this.fix.paymentsAttributes[1].referralId = val.referralId
        }
      },
    },

    payer: {
      handler (val) {
        this.fix.payerType = val.referralType
        this.fix.payerId = val.referralId

        this.fix.paymentsAttributes[1].referralType = val.referralType
        this.fix.paymentsAttributes[1].referralId = val.referralId
      },
    },

    'fix.amount' (val) {
      this.fix.paymentsAttributes.forEach( (p, i) => {
        if (i) {
          p.amount = Math.abs(val)
        } else {
          p.amount = Math.abs(val) * -1
        }
      })
    },

    concept: {
      handler (val) {
        this.fix.paymentsAttributes[0].concept = val.name
        this.fix.paymentsAttributes[0].conceptId = val.id

        this.fix.paymentsAttributes[1].concept = val.name
        this.fix.paymentsAttributes[1].conceptId = val.id
      },

      deep: true
    },
  },

  mounted () {
    this.fetchTicket()
  },

  methods: {
    fetchTicket () {
      this.$apollo.query({
        query: Ticket,
        variables: {
          ticketId: this.$route.params.ticket_id
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        this.ticket = res.data.ticket
        
        let property = this.ticket.contract.property

        this.fix.name = this.ticket.title
        this.fix.propertyId = property.id
        this.fix.contractId = this.ticket.contract.id
        this.fix.ticketId = this.ticket.id
        this.fix.payerId = property.owner[0].id
        this.fix.paymentsAttributes[0].subAccountId = property.fixesSubAccountId
        this.fix.paymentsAttributes[0].contractId = this.ticket.contract.id
        this.fix.paymentsAttributes[0].state = 'paid'
        this.fix.paymentsAttributes[0].paidAt = (new Date)
        this.fix.paymentsAttributes[0].referralId = property.agencyId
        this.fix.paymentsAttributes[0].referralType = 'Agency'

        this.fetchConcepts()

        this.fix.paymentsAttributes.push({
          referralId: property.agencyId,
          referralType: 'Agency',
          concept: 'Reparaciones',
          state: 'pending',
          period: "0",
          dueDate: (new Date()),
          amount: null,
          subAccountId: property.fixesSubAccountId,
          contractId: this.ticket.contract.id
        })
      })
    },

    editTicket () {
      if (this.valid) this.valid = this.$refs.form.validate()

      if (this.valid) {
        this.$apollo.mutate({
          mutation: EditTicket,
          variables: {
            input: {
              id: this.$route.params.ticket_id,
              attributes: {
                title: this.ticket.title,
                state: this.ticket.state
              }
            }
          }
        }).then(res => {
          this.fetchTicket()
          this.editModal = false
        })
      }
    },

    cancel () {
      this.fetchTicket()
      this.editModal = false
    },

    addComment () {
      if (this.comment) {
        this.$apollo.mutate({
          mutation: EditTicket,
          variables: {
            input: {
              id: this.$route.params.ticket_id,
              attributes: {
                descriptionsAttributes: [
                  {
                    description: this.comment
                  }
                ]
              }
            }
          }
        }).then(res => {
          this.comment = null
          this.fetchTicket()
        })
      }
    },

    createFix () {
      if (this.valid_fix) this.valid_fix = this.$refs.fix_form.validate()

      if (this.valid_fix) {

        this.$apollo.mutate({
          mutation: CreateFix,
          variables: {
            input: {
              attributes: this.fix
            }
          }
        }).then(res => {
          this.fetchTicket()
          this.createFixModal = false
        })
      }
    },

    deleteFix (id) {
      this.$apollo.mutate({
        mutation: DeleteFix,
        variables: {
          input: {
            id: id
          }
        }
      }).then(res => {
        this.fetchTicket()
        this.dialog = false
      })
    },

    fetchConcepts () {
      this.$apollo.query({
        query: Concepts,
        variables: {
          subAccountId: this.fix.paymentsAttributes[0].subAccountId
        },
        fetchPolicy: 'no-cache'
      }).then( res => {
        this.concepts = res.data.concepts
      })
    },
  }
}
</script>
